import React, { useEffect, useState } from 'react'
import {
	Dialog,
	AppBar,
	Toolbar,
	IconButton,
	Typography,
	Grid,
	Fab,
	Checkbox,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import AddIcon from '@material-ui/icons/Add'
import EditIcon from '@material-ui/icons/EditOutlined'
import Card from '@material-ui/core/Card'
import MuiCardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import MailIcon from '@material-ui/icons/MailOutlined'
import PhoneIcon from '@material-ui/icons/PhoneOutlined'
import PhonelinkEraseIcon from '@material-ui/icons/PhonelinkEraseOutlined'
import { makeStyles } from '@material-ui/styles'
import { useTranslation } from 'react-i18next'
import { useSession } from '../../containers/SessionContainer'
import { findContactById } from '../../constants/contacts'
import i18next from '../../i18n'
import SlidingForm from '../../components/Form/SlidingForm'
import FormIcon from '../../components/Form/FormIcon'
import FormButtonIcon from '../../components/Form/FormButtonIcon'
import FormButtonIconDelete from '../../components/Form/FormButtonIconDelete'
import InputText from '../../components/Form/input/InputText'
import InputMail from '../../components/Form/input/InputMail'
import InputPhone from '../../components/Form/input/InputPhone'
import InputCheckbox, { InputSwitch } from '../../components/Form/input/InputCheckbox'
import { Form } from 'react-final-form'
import { composeValidators } from '../../utils/Form'
import { required, maxLong } from '../../utils/VerifyFields'
import { useSnackbar } from 'notistack'

const CONTACT_TYPES = [
	{ id: 1, code: 'D', name: 'Directeur' },
	{ id: 2, code: 'RA', name: 'Responsable agence' },
	{ id: 3, code: 'SST', name: 'Responsable SST' },
	{ id: 4, code: 'MT', name: 'Médecin du travail' },
	{ id: 5, code: 'RP', name: 'Représentant du personnel' },
	{ id: 6, code: 'HSE', name: 'Responsable HSE' },
	{ id: 8, code: 'CP', name: 'Contact produit' },
	{ id: 9, code: 'RO', name: 'Responsable Opération' },
	{ id: 10, code: 'RT', name: 'Responsable Technique' },
]

const useStyles = makeStyles((theme) => ({
	appBar: {
		position: 'relative',
	},
	dialogTitle: {
		flex: 1,
		textAlign: 'center',
		fontWeight: 400,
	},
	sentence: {
		margin: '20px',
		color: theme.palette.secondary.main,
	},
	filters: {
		color: theme.palette.secondary.main,
		display: 'inline-block',
		margin: 15,
	},
	container: {
		padding: theme.spacing.unit,
		paddingBottom: theme.spacing.unit * 10,
	},
	card: {
		minHeight: 180,
		position: 'relative',
		margin: '10px',
	},
	cardIcon: {
		position: 'absolute',
		top: 5,
		right: 5,
		cursor: 'pointer',
	},
	title: {
		fontSize: 16,
		color: theme.palette.secondary.main,
		paddingRight: '10%',
		display: 'block',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
	separator: {
		width: '90%',
		height: 1,
		border: 'none',
		backgroundColor: '#d6d6d6',
	},
	icons: {
		color: 'black',
	},
	link: {
		color: 'black !important',
		textDecoration: 'none',
		display: 'block',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		fontSize: 11,
	},
	cardHeader: {
		display: 'list-item',
		paddingBottom: 5,
	},
	iconList: {
		display: 'flex',
		flexDirection: 'row-reverse',
	},
	icon: {
		marginLeft: theme.spacing.unit,
		marginRight: theme.spacing.unit,
		height: '27px',
	},
	cardContent: {
		'&:last-child': {
			padding: 1,
		},
	},
	listContent: {
		padding: 1,
		margin: 1,
	},
	listItem: {
		paddingTop: 5,
		paddingBottom: 5,
	},
	item: {
		padding: 0,
	},
	fab: {
		position: 'fixed',
		bottom: theme.spacing.unit * 2,
		right: theme.spacing.unit * 2,
		zIndex: 1,
	},
	size1: {
		marginTop: '15px',
		marginBottom: '15px',
	},
	validateButton: {
		marginLeft: 0,
		marginRight: 0,
	},
	deleteButton: {
		marginRight: 0,
	},
	validateGroup: {
		display: 'flex',
	},
	emptyMessage: {
		textAlign: 'center',
		color: theme.palette.text.secondary,
		marginTop: 40,
	},
}))

function OverviewContactsDialog({ openDialog, setOpenDialog }) {
	const classes = useStyles()
	const { t } = useTranslation(['user', 'contacts'])
	const { enqueueSnackbar } = useSnackbar()
	const { session, setSession } = useSession('signup')
	const [contacts, setContacts] = useState([])
	const [contactsFilters, setContactsFilters] = useState([])
	const [contactsFiltered, setContactsFiltered] = useState([])
	const [showForm, setShowForm] = useState(false)
	const [editingContact, setEditingContact] = useState(null)
	const [language, setLanguage] = useState(1)

	useEffect(() => {
		switch (i18next.language) {
			case 'en':
				setLanguage(2)
				break
			default:
				setLanguage(1)
				break
		}
	}, [])

	useEffect(() => {
		if (!openDialog) return
		setContactsFilters(InitializeFilters())
		if (!session) {
			setContacts([])
			return
		}
		const tmpSession = JSON.parse(session)
		if (tmpSession && tmpSession.contactsInfo) {
			setContacts(tmpSession.contactsInfo)
		} else {
			setContacts([])
		}
	}, [openDialog, session])

	useEffect(() => {
		if (!contactsFilters.length) return
		let result = contacts.filter((contact) => {
			if (contactsFilters.find((filter) => filter.key === 'all').show === true) return true
			if (contactsFilters.some((filter) => filter.show))
				return contactsFilters.some((filter) => filter.show && contact[filter.key])
			return false
		})
		setContactsFiltered(result)
	}, [contactsFilters, contacts])

	const InitializeFilters = () => {
		return [
			{
				id: 1,
				key: 'all',
				key_label: 'all',
				show: true,
			},
			{
				id: 2,
				key: 'isNotifiable',
				key_label: 'notifiable_account',
				show: false,
			},
		]
	}

	const toggleCheckbox = (event) => {
		let v_contactsFilters = [...contactsFilters]
		if (event.target.checked) {
			let v_filter = v_contactsFilters.find((filter) => filter.id == event.target.dataset.value)
			v_filter.show = true
			if (v_filter.key !== 'all') {
				v_contactsFilters.find((filter) => filter.key === 'all').show = false
			}
		} else {
			v_contactsFilters.find((filter) => filter.id == event.target.dataset.value).show = false
		}
		setContactsFilters(v_contactsFilters)
	}

	const DisplayFilters = () => {
		return (
			<div>
				{contactsFilters.map((filter) => (
					<div className={classes.filters} key={filter.id}>
						<span>{t(filter.key_label)}</span>
						<Checkbox
							name={`name-checkbox-${filter.id}`}
							onChange={toggleCheckbox}
							checked={filter.show}
							inputProps={{
								'data-value': filter.id,
							}}
						/>
					</div>
				))}
			</div>
		)
	}

	const saveContactsToSession = (updatedContacts) => {
		const tmpSession = session ? JSON.parse(session) : {}
		const newSession = { ...tmpSession, contactsInfo: updatedContacts }
		setSession(JSON.stringify(newSession))
		setContacts(updatedContacts)
	}

	const handleEdit = (contact) => {
		setEditingContact(contact)
		setShowForm(true)
	}

	const handleDelete = (id) => {
		const updatedContacts = contacts.filter((c) => c.id !== id)
		saveContactsToSession(updatedContacts)
		enqueueSnackbar(t('TheContactHasBeenDeleted'), { variant: 'info' })
		setShowForm(false)
		setEditingContact(null)
	}

	const handleClose = () => {
		setShowForm(false)
		setOpenDialog(false)
	}

	const getInitialValues = () => {
		if (!editingContact) return { notifie: false }
		let typesValues = {}
		if (editingContact.typesIds) {
			for (const typeId of editingContact.typesIds) {
				typesValues['type' + typeId] = true
			}
		}
		return {
			lastname: editingContact.name,
			firstname: editingContact.firstName,
			mail: editingContact.email,
			phone: editingContact.phone,
			notifie: editingContact.isNotifiable || false,
			...typesValues,
		}
	}

	const onSubmit = (values) => {
		let typesIds = []
		for (const type of CONTACT_TYPES) {
			if (values['type' + type.id]) typesIds.push(type.id)
		}

		if (typesIds.length === 0) {
			enqueueSnackbar(t('CheckAtLeastOneType'), { variant: 'error' })
			return
		}

		const contactData = {
			id: editingContact ? editingContact.id : Date.now(),
			name: values.lastname,
			firstName: values.firstname,
			email: values.mail,
			phone: values.phone,
			isNotifiable: !!values.notifie,
			typesIds,
		}

		if (editingContact) {
			const updatedContacts = contacts.map((c) => (c.id === editingContact.id ? contactData : c))
			saveContactsToSession(updatedContacts)
			enqueueSnackbar(t('TheContactHasBeenUpdated'), { variant: 'info' })
		} else {
			saveContactsToSession([...contacts, contactData])
			enqueueSnackbar(t('TheContactHasBeenAdded'), { variant: 'info' })
		}
		setShowForm(false)
		setEditingContact(null)
	}

	return (
		<>
			<SlidingForm
				direction="vertical"
				open={showForm}
				title={t('contacts:AddContact')}
				iconAttachement={
					<>
						<FormIcon icon="clear" onClick={() => { setShowForm(false); setEditingContact(null) }} />
					</>
				}
				onClose={() => { setShowForm(false); setEditingContact(null) }}
			>
				<Form
					onSubmit={onSubmit}
					initialValues={getInitialValues()}
					render={({ handleSubmit }) => (
						<form onSubmit={handleSubmit} style={{ width: '95%' }}>
							<InputText
								classes={{ root: classes.size1 }}
								validate={composeValidators(required, maxLong)}
								name="lastname"
								label={t('lastname')}
							/>
							<InputText
								classes={{ root: classes.size1 }}
								validate={composeValidators(required, maxLong)}
								name="firstname"
								label={t('firstname')}
							/>
							<InputMail
								classes={{ root: classes.size1 }}
								validate={composeValidators(required, maxLong)}
								name="mail"
								label={t('email')}
							/>
							<InputPhone
								classes={{ root: classes.size1 }}
								validate={composeValidators(required, maxLong)}
								name="phone"
								label={t('phone')}
							/>
							<InputSwitch name="notifie" label={t('notifie')} />
							{CONTACT_TYPES.map((type) => (
								<InputCheckbox
									name={'type' + type.id}
									label={`(${type.code}) ${type.name}`}
									value={type.id}
									key={type.id}
								/>
							))}
							<div className={classes.validateGroup}>
								{editingContact && (
									<FormButtonIconDelete
										classes={{ root: classes.deleteButton }}
										onClick={() => handleDelete(editingContact.id)}
									/>
								)}
								<FormButtonIcon type="submit" classes={{ root: classes.validateButton }} />
							</div>
						</form>
					)}
				/>
			</SlidingForm>

			<Dialog fullScreen open={openDialog} onClose={handleClose} style={{ zIndex: 1100 }}>
				<AppBar className={classes.appBar}>
					<Toolbar>
						<Typography variant="h6" color="inherit" className={classes.dialogTitle}>
							{t('contacts')}
						</Typography>
						<IconButton color="inherit" onClick={handleClose} aria-label="Close">
							<CloseIcon />
						</IconButton>
					</Toolbar>
				</AppBar>

				<p className={classes.sentence}>
					<strong>{t('warningContactPage1')}</strong> {t('warningContactPage2')}
					<br />
					<br />
					<span style={{ color: 'red' }}>{t('contactsWarning')}</span>
				</p>

				<DisplayFilters />

			<div className={classes.container}>
				{contactsFiltered.length === 0 && (
					<Typography variant="body1" className={classes.emptyMessage}>
						{t('noContact')}
					</Typography>
				)}

				<Grid container spacing={4} direction="row">
					{contactsFiltered.map((contact) => {
						const typeIcons = (contact.typesIds || [])
							.map((id) => {
								const found = findContactById(id)
								return found && found[0] ? found[0].icon : null
							})
							.filter(Boolean)

						return (
							<Grid item xs={12} sm={6} md={3} key={contact.id}>
								<Card className={classes.card}>
									<IconButton
										className={classes.cardIcon}
										aria-label="Edit"
										onClick={() => handleEdit(contact)}
									>
										<EditIcon className={classes.icons} />
									</IconButton>
									<MuiCardHeader
										title={
											<Typography className={classes.title} variant="h6">
												{contact.firstName} {contact.name}
											</Typography>
										}
										titleTypographyProps={{ color: 'inherit' }}
										className={classes.cardHeader}
									/>
									<hr className={classes.separator} />
									<CardContent className={classes.cardContent}>
										<List className={classes.listContent}>
											<ListItem className={classes.listItem}>
												<ListItemIcon>
													<MailIcon className={classes.icons} />
												</ListItemIcon>
												<ListItemText className={classes.item}>
													<a
														className={classes.link}
														href={`mailto:${contact.email}`}
														target="_blank"
														rel="noopener noreferrer"
													>
														{contact.email}
													</a>
												</ListItemText>
											</ListItem>
											<ListItem className={classes.listItem}>
												<ListItemIcon>
													{contact.phone ? (
														<PhoneIcon className={classes.icons} />
													) : (
														<PhonelinkEraseIcon className={classes.icons} />
													)}
												</ListItemIcon>
												<ListItemText className={classes.item}>
													{contact.phone ? (
														<a
															className={classes.link}
															href={`tel:${contact.phone}`}
															target="_blank"
															rel="noopener noreferrer"
														>
															{contact.phone}
														</a>
													) : (
														<span className={classes.link}>{t('NoPhoneNumber')}</span>
													)}
												</ListItemText>
											</ListItem>
										</List>
										<div className={classes.iconList}>
											{typeIcons.map((iconSrc, i) => (
												<img key={i} src={iconSrc} alt="icon" className={classes.icon} />
											))}
										</div>
									</CardContent>
								</Card>
							</Grid>
						)
					})}
				</Grid>
			</div>

				<Fab
					className={classes.fab}
					color="secondary"
					onClick={() => { setEditingContact(null); setShowForm(true) }}
				>
					<AddIcon />
				</Fab>
			</Dialog>
		</>
	)
}

export default OverviewContactsDialog
